
export const TRAMITE_PENSION_INVALIDEZ_ERROR_GENERAL_INICIO_MAX_REINTENTOS = 3;
export const SESSION_TRAMITE_PENSION_INVALIDEZ_ERROR_GENERAL_INICIO_REINTENTOS_RESTANTES =
  "tpi-error-general-inicio-reintentos-restantes";

export const MESSAGE = {

  ERROR_500: {
    title: "Lo sentimos, en este momento no podemos atender la solicitud.",
    subtitle: "El servicio no se encuentra disponible. Por favor, vuelve a intentarlo más tarde.",
    message:
      "Actualmente tenemos un problema con nuestros servicios, podrás intentarlo nuevamente más tarde.",
    textButton: "Aceptar",
    eventClickButton: "goToHome",
    backButton: false
  },

  ERROR_404: {
    title: "Lo sentimos, no encontramos está página",
    subtitle: "El servicio no se encuentra disponible. Por favor, vuelve a intentarlo más tarde.",
    message:
      "Actualmente tenemos un problema con nuestros servicios, podrás intentarlo nuevamente más tarde.",
    textButton: "Aceptar",
    eventClickButton: "goToHome",
    backButton: false
  },

  ERROR_GENERAL_INICIAR_TRAMITE: {
    useGeneralErrorLayout: true,
    title: "En este momento no podemos atender tu solicitud",
    subtitle:
      "El servicio no se encuentra disponible.<br>Puedes intentarlo de nuevo o volver más tarde.",
    infoBoxHtml:
      '<h4 class="ds-text-h4-bold">¿Necesitas ayuda?</h4><p class="ds-text-body-regular elimina-margen">Llámanos al <a href="tel:+566006600900">600 6600 900</a>, escríbenos al WhatsApp <a href="https://wa.me/56936391222" target="_blank" rel="noopener noreferrer">+569 3639 1222</a> o agenda una <a href="/video-atencion">Video Atención</a>.</p>',
    textButton: "Reintentar",
    eventClickButton: "goToTramitePensionInicio",
    textButton2: "Ir a Inicio",
    eventClickButton2: "goToAppHome",
    backButton: false,
  },

  /** Tras el 3.er intento fallido: sin Reintentar, ofrece Video Atención. */
  ERROR_GENERAL_INICIAR_TRAMITE_SIN_REINTENTOS: {
    useGeneralErrorLayout: true,
    title: "En este momento no podemos atender tu solicitud",
    subtitle:
      "El servicio no se encuentra disponible.<br>Puedes volver más tarde o comunicarte con nosotros.",
    infoBoxHtml:
      '<h4 class="ds-text-h4-bold">¿Necesitas ayuda?</h4><p class="ds-text-body-regular elimina-margen">Llámanos al <a href="tel:+566006600900">600 6600 900</a>, escríbenos al WhatsApp <a href="https://wa.me/56936391222" target="_blank" rel="noopener noreferrer">+569 3639 1222</a> o agenda una <a href="/video-atencion">Video Atención</a>.</p>',
    textButton: "Agendar Video Atención",
    eventClickButton: "goToVideoAtencion",
    textButton2: "Ir a Inicio",
    eventClickButton2: "goToAppHome",
    backButton: false,
  },

  ERROR_GENERAL_LIMITE_EDAD: {
    iconName: "InfoFill",
    title: "Tu solicitud necesita atención de un ejecutivo",
    subtitle: "Como estás a menos de 6 meses de cumplir 65 años, tu caso debe ser revisado por un ejecutivo para que se complete correctamente. <p>Te sugerimos agendar una Video Atención para continuar con tu trámite.</p>",
    infoBoxHtml:
      '<h4 class="ds-text-h4-xl-bold">¿Necesitas ayuda?</h4><p class="ds-text-body-regular">Llámanos al <a href="tel:+566006600900">600 6600 900</a>, escríbenos al WhatsApp <a href="https://wa.me/56936391222" target="_blank" rel="noopener noreferrer">+569 3639 1222</a> o agenda una <a href="/video-atencion">Video Atención</a>.</p>',
    buttonTextPrimary: "Agendar Video Atención",
    buttonUrlPrimary: "/video-atencion",
    buttonElementoPrimary: 'boton_agendar_video_atencion',
    buttonElementoTipoPrimary: 'boton_principal',
    buttonTextSecondary: "Ir a Inicio",
    buttonElementoSecondary: 'boton_ir_a_inicio',
    buttonElementoTipoSecondary: 'boton_secundario',
    buttonUrlSecondary: "/inicio",
    motivo: 'proximidad_65_anos',
  },

  MENSAJE_REALIZAR_SOLICITUD_MUTUALIDAD: {
    iconName: "InfoFill",
    title: "Realiza esta solicitud en tu mutualidad",
    subtitle: "Como tu invalidez es de origen laboral, debes realizar esta solicitud en la mutualidad de seguridad.",
    infoBoxHtml:
      '<h4 class="ds-text-h4-xl-bold">¿Necesitas ayuda?</h4><p class="ds-text-body-regular">Llámanos al <a href="tel:+566006600900">600 6600 900</a>, escríbenos al WhatsApp <a href="https://wa.me/56936391222" target="_blank" rel="noopener noreferrer">+569 3639 1222</a> o agenda una <a href="/video-atencion">Video Atención</a>.</p>',
    buttonTextPrimary: "Agendar Video Atención",
    buttonUrlPrimary: "/video-atencion",
    buttonElementoPrimary: 'boton_agendar_video_atencion',
    buttonElementoTipoPrimary: 'boton_principal',
    buttonTextSecondary: "Ir a Inicio",
    buttonElementoSecondary: 'boton_ir_a_inicio',
    buttonElementoTipoSecondary: 'boton_secundario',
    buttonUrlSecondary: "/inicio",
  },

  ERROR_NO_CUMPLE_REQUISITOS: {
    title: "No cumples con los requisitos para realizar la solicitud de pensión",
    subtitle:
      "Esta solicitud es para trabajadores del sector privado y <b>no considera casos de beneficiarios con algún tipo de invalidez o empleados del sector público</b>.<br>Es probable que este sea tu caso o que debas actualizar tu información personal.",
    message: "Te aconsejamos agendar una Video Atención en donde uno de nuestros ejecutivos puede orientarte.",
    textButton: "Agendar Video Atención",
    eventClickButton: "goToVideoAtencion",
  },
  ERROR_NO_CUMPLE_REQUISITOS_EXTRANJERO: {
    title: "No cumples con los requisitos para realizar la solicitud de pensión",
    subtitle:
      "Esta solicitud es para trabajadores del sector privado y <b>no considera casos de beneficiarios con algún tipo de invalidez o empleados del sector público</b>.<br>Es probable que este sea tu caso o que debas actualizar tu información personal.",
    message: "Te aconsejamos agendar una Video Atención en donde uno de nuestros ejecutivos puede orientarte.",
    textButton: "Agendar Video Atención",
    eventClickButton: "goToVideoAtencion",
  },

  ERROR_INGRESO_SERVICIOS_TRAMITE_PENSION: {
    title: "No cumples con los requisitos para realizar la solicitud de pensión",
    subtitle: 'Puedes intentarlo más tarde o ingresar tu trámite de pensión a través de estas dos alternativas:<br> <br> <ol>  <li>Agenda una Video Atención con uno de nuestros ejecutivos.</li> <li>Accede a nuestra asistente virtual Clara y en el menú selecciona "Video Atención", en donde un ejecutivo te atenderá de forma inmediata.</li>   </ol>',
    message: "Te aconsejamos agendar una Video Atención en donde uno de nuestros ejecutivos puede orientarte.",
    textButton: "Agendar Video Atención",
    eventClickButton: "goToVideoAtencion",
    textButton2: "Preguntar a Clara",
    eventClickButton2: "goToClara",
  },

  ERROR_NO_CUMPLE_CON_ESTADO_CIVIL_VALIDACION: {
    iconName: "InfoFill",
    title: "No cumples los requisitos para realizar la solicitud de pensión",
    subtitle: "Según nuestros registros, tu estado civil no te permite avanzar con esta solicitud.",
    infoBoxHtml:
      '<h3 class="ds-text-h3-s-bold">¿Qué viene ahora?</h3><p class="ds-text-body-regular">Para presentar tu solicitud de pensión, te sugerimos agendar una Video Atención para que un ejecutivo valide tu estado civil.</p>',
    buttonTextPrimary: "Agendar Video Atención",
    buttonUrlPrimary: "/video-atencion",
    buttonElementoPrimary: 'boton_agendar_video_atencion',
    buttonElementoTipoPrimary: 'boton_principal',
    buttonTextSecondary: "Preguntar a Clara",
    buttonElementoSecondary: 'boton_preguntar_a_clara',
    buttonElementoTipoSecondary: 'boton_secundario',
    buttonUrlSecondary: "/clara",
  },

  ERROR_BENEFICIARIO_CON_INVALIDEZ: {
    iconName: "InfoFill",
    title: "Tu solicitud de pensión necesita la atención de un ejecutivo",
    subtitle: "El trámite en línea no contempla beneficiarios con algún tipo de invalidez.",
    tituloLista: "¿Por qué no se consideran estos casos?",
    lista: ["Porque requieren un análisis especial de nuestros ejecutivos, para asegurar que no pierdas ningún beneficio legal."],
    message: "Te sugerimos agendar una Video Atención para iniciar tu trámite.",
    textButton: "Agendar Video atención",
    eventClickButton: "goToVideoAtencion",
  },

  ERROR_NO_AHORROS_OBLIGATORIOS_AFP_CAPITAL: {
    iconName: "InfoFill",
    title: "No cumples con los requisitos para realizar la solicitud de pensión",
    subtitle: "Para iniciar este trámite debes tener tu Ahorro Obligatorio en AFP Capital, pero según nuestros registros los tienes en otra administradora.",
    infoBoxHtml:
      '<h3 class="ds-text-h3-s-bold">¿Qué viene ahora?</h3><p class="ds-text-body-regular">Realiza la solicitud en la AFP que tengas tu Ahorro Obligatorio.</p>',
    buttonTextPrimary: "Agendar Video Atención",
    buttonUrlPrimary: "/video-atencion",
    buttonElementoPrimary: 'boton_agendar_video_atencion',
    buttonElementoTipoPrimary: 'boton_principal',  
  },

  ERROR_SIN_SALDOS_OBLIGATORIOS_AFP_CAPITAL: {
    iconName: "InfoFill",
    title: "No cumples los requisitos para realizar la solicitud de pensión",
    subtitle:
      "Según nuestros registros, no cuentas con ahorros suficientes iniciar el trámite.",
    infoBoxHtml:
      '<h3 class="ds-text-h3-s-bold">¿Qué viene ahora?</h3><p class="ds-text-body-regular">Hay alternativas del Estado pensadas para ti. Agenda una Video Atención y un ejecutivo te explicará cuáles son y cómo acceder a ellas.</p>',
    buttonTextPrimary: "Agendar Video Atención",
    buttonUrlPrimary: "/video-atencion",
    buttonElementoPrimary: "boton_agendar_video_atencion",
    buttonElementoTipoPrimary: "boton_principal",
  },

  VALIDACION_SOLICITUD_EN_CURSO: {
    iconName: "InfoFill",
    title: "Tu solicitud de pensión está en curso",
    subtitle:
      "Para tu respaldo, enviamos una copia de la Solicitud de Pensión a tu correo.",
    infoBoxHtml:
      '<h3 class="ds-text-h3-s-bold">¿Qué viene ahora?</h3><p class="ds-text-body-regular">Nos contactaremos contigo por correo para informar sobre el resultado de tu solicitud, próximos pasos e información relevante del trámite.</p>',
    buttonTextPrimary: "Agendar Video Atención",
    buttonUrlPrimary: "/video-atencion",
    buttonElementoPrimary: "boton_agendar_video_atencion",
    buttonElementoTipoPrimary: "boton_principal",
  },

  VALIDACION_CLIENTE_FALLECIDO: {
    iconName: "InfoFill",
    title: "No es posible continuar con la solicitud",
    subtitle:
      "Según nuestros registros, no es posible cursar esta solicitud de pensión por invalidez.",
    infoBoxHtml:
      '<h3 class="ds-text-h3-s-bold">¿Necesitas ayuda?</h3><p class="ds-text-body-regular">Llámanos al <a href="tel:+566006600900">600 6600 900</a>, escríbenos al WhatsApp <a href="https://wa.me/56936391222" target="_blank" rel="noopener noreferrer">+569 3639 1222</a> o agenda una <a href="/video-atencion">Video Atención</a>.</p>',
    buttonTextPrimary: "Agendar Video Atención",
    buttonUrlPrimary: "/video-atencion",
    buttonElementoPrimary: "boton_agendar_video_atencion",
    buttonElementoTipoPrimary: "boton_principal",
  },

  ERROR_LPA_SALDO_RETENIDO: {
    title: "No podemos ingresar tu solicitud de pensión",
    subtitle:
      "Según nuestros registros, tu saldo esta retenido por una resolución judicial notificada de acuerdo a la Ley Nº 21.484. Podrás realizar el trámite una vez se regularice la situación.",
    message:
      "Te aconsejamos agendar una Video Atención en donde uno de nuestros ejecutivos puede orientarte.",
    textButton: "Agendar Video Atención",
    eventClickButton: "goToVideoAtencion",
    buttonUrlPrimary: "/video-atencion",
    textButton2: "Preguntar a Clara",
    eventClickButton2: "goToClara",
    buttonUrlSecondary: "/clara",
  },

  ERROR_APVC_SALDO: {
    title: "No podemos ingresar tu solicitud de pensión",
    subtitle:
      "Según nuestros registros, tienes una cuenta de <b>Ahorro Previsional Voluntario Colectivo - APVC</b> que no permite avanzar con la solicitud en línea.",
    message:
      "Te aconsejamos agendar una Video Atención en donde uno de nuestros ejecutivos puede orientarte.",
    textButton: "Agendar Video Atención",
    eventClickButton: "goToVideoAtencion",
    useAlertIcon: true,
  },

  ERROR_BENEFICIARIOS_VALIDACION_AGRUPADA: {
    iconName: "InfoFill",
    title: "Tus beneficiarios necesitan una revisión",
    tituloLista: "¿Por qué no puedes continuar con la solicitud?",
    introLista:
      "Porque encontramos al menos una de estas situaciones en tu lista de beneficiarios:",
    lista: [],
    message: "Es necesario que edites tus beneficiarios o elimines a los que no cumplen con los requisitos.",
    textButton: "Editar beneficiarios",
    eventClickButton: "goToBeneficiario",
    textButton2: "Agendar Video atención",
    eventClickButton2: "goToVideoAtencion",
  },
};

export const CUENTA_OBLIGATORIA = 'CCO';
